import { type PartnerInfo } from "./types"

/**
 * Structurally nav-less, like the header: the partner's copyright line and
 * nothing else — this is a landing page, not a website.
 */
export function Footer({ partner }: { partner: PartnerInfo }) {
  return (
    <footer className="w-full px-4 sm:px-8">
      <div className="border-lp-border/70 text-lp-muted mx-auto flex w-full max-w-5xl flex-col items-center justify-between gap-2 border-t py-8 text-sm sm:flex-row">
        <p>
          © {new Date().getFullYear()} {partner.name}
        </p>
      </div>
    </footer>
  )
}
